import { render } from "./ProductGroupList.vue?vue&type=template&id=008dac2b&scoped=true"
import script from "./ProductGroupList.vue?vue&type=script&lang=js"
export * from "./ProductGroupList.vue?vue&type=script&lang=js"

import "./ProductGroupList.vue?vue&type=style&index=0&id=008dac2b&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008dac2b"]])

export default __exports__